import adobeLogo from "@circle-assets/images/onboarding/adobe-logo.svg";
import harvardLogo from "@circle-assets/images/onboarding/harvard-logo.svg";
import miroLogo from "@circle-assets/images/onboarding/miro-logo.svg";
import notionLogo from "@circle-assets/images/onboarding/notion-logo.svg";
import spacexLogo from "@circle-assets/images/onboarding/spacex-logo.svg";
import webflowLogo from "@circle-assets/images/onboarding/webflow-logo.svg";

const logoMap = {
  Adobe: adobeLogo,
  Notion: notionLogo,
  SpaceX: spacexLogo,
  Webflow: webflowLogo,
  Harvard: harvardLogo,
  Miro: miroLogo,
};

type Company = keyof typeof logoMap;

interface LogoProps {
  className?: string;
  company: Company;
}

export const Logo = ({ className, company }: LogoProps) => {
  const logoPath = logoMap[company];

  return (
    <img
      src={logoPath}
      alt={`${company} logo`}
      className={className}
      loading="lazy"
    />
  );
};
